import { render, staticRenderFns } from "./vehicleLoadDetail.vue?vue&type=template&id=f8ee12d8&scoped=true"
import script from "./vehicleLoadDetail.vue?vue&type=script&lang=js"
export * from "./vehicleLoadDetail.vue?vue&type=script&lang=js"
import style0 from "./vehicleLoadDetail.vue?vue&type=style&index=0&id=f8ee12d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ee12d8",
  null
  
)

export default component.exports